import Vue from 'vue';
export default {
  data() {
    return {
      searchTitle: '',
      searchModal: false,
      isSearch: false,
      searchFromDate: '',
      searchToDate: '',
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
      //row 1
      callsCount: null,
      accidentsCount: null,
      missionPhonesCount: null,
      patientsCount: null,
      callTillArriveToLocationAverageTime: {
        city: '',
        road: '',
      },
      moveFromLocationTillArriveToHospitalAverageTime: {
        city: '',
        road: '',
      },
      fenceCallTillArriveToLocationAverageTime: {
        city: '',
        road: '',
      },
      fenceMoveFromLocationTillArriveToHospitalAverageTime: {
        city: '',
        road: '',
      },
      //row 2
      //pie rank
      dashboardPieRankChartOptions: {
        colors: [],
        chart: {
          renderTo: 'dashboardPieRankChart',
          type: 'pie',
          height: '240px',
          redraw: true,
        },
        title: {
          text: '',
        },
        legend: {
          layout: 'vertical',
          useHTML: true,
          enabled: false,
          rtl: true,
          align: 'right',
          verticalAlign: 'middle',
          itemMarginTop: 3,
          itemMarginBottom: 3,
          itemStyle: {
            fontSize: '10px',
            direction: 'ltr',
            textAlign: 'left',
            width: '80px',
          },
        },
        series: [
          {
            name: '',
            keys: ['name', 'y', 'tooltipText'],
            colorByPoint: true,
            data: [],
            size: '100%',
            slicedOffset: 5,
            showInLegend: true,
            useHTML: true,
          },
        ],
        plotOptions: {
          pie: {
            innerSize: 90,
            depth: 50,
            dataLabels: {
              enabled: true,
              useHTML: true,
              style: {
                fontSize: '9px',
                textOutline: 'none',
                color: '#ffffff',
              },
            },
          },
          useHTML: true,
          series: {
            title: 'اولویت ها',
            cursor: 'pointer',
            borderRadius: 5,
            dataLabels: [
              {
                enabled: true,
                distance: 15,
                format: '{point.name}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
              {
                enabled: true,
                distance: '-20%',
                format: '{point.y}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
            ],
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{point.tooltipText}</span>: <span  style="color:white">{point.y}</span></div><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">درصد</span>: <span  style="color:white">{point.percentage:.2f}</span></div>',
        },
      },
      //pie Geographical
      pieGeographicalChartOption: {
        colors: ['#46DDFF', '#DE72D0', '#649DDE'],
        chart: {
          renderTo: 'dashboardQCPieCallChart',
          type: 'pie',
          height: '240px',
          redraw: true,
        },
        title: {
          text: '',
        },
        legend: {
          layout: 'vertical',
          useHTML: true,
          enabled: false,
          rtl: true,
          align: 'right',
          verticalAlign: 'middle',
          itemMarginTop: 3,
          itemMarginBottom: 3,
          itemStyle: {
            fontSize: '10px',
            direction: 'ltr',
            textAlign: 'left',
            width: '80px',
          },
        },
        series: [
          {
            name: '',
            keys: ['name', 'y', 'tooltipText'],
            colorByPoint: true,
            data: [],
            size: '100%',
            slicedOffset: 5,
            showInLegend: true,
            useHTML: true,
          },
        ],
        plotOptions: {
          pie: {
            innerSize: 0,
            depth: 0,
            dataLabels: {
              enabled: true,
              useHTML: true,
              style: {
                fontSize: '9px',
                textOutline: 'none',
                color: '#ffffff',
              },
            },
          },
          useHTML: true,
          series: {
            title: 'تماس',
            cursor: 'pointer',
            borderRadius: 5,
            dataLabels: [
              {
                enabled: true,
                distance: 15,
                format: '{point.name}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
              {
                enabled: true,
                distance: '-20%',
                format: '{point.y}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
            ],
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{point.tooltipText}</span>: <span  style="color:white">{point.y}</span></div><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">درصد</span>: <span  style="color:white">{point.percentage:.2f}</span></div>',
        },
      },
      //pie code type
      pieCodeTypeChartOption: {
        colors: ['#D6558B', '#55BCE8', '#665FBB', '#EED54A '],
        chart: {
          renderTo: 'pieCodeTypeChart',
          type: 'pie',
          height: '240px',
          redraw: true,
        },
        title: {
          text: '',
        },
        legend: {
          layout: 'vertical',
          useHTML: true,
          enabled: false,
          rtl: true,
          align: 'right',
          verticalAlign: 'middle',
          itemMarginTop: 3,
          itemMarginBottom: 3,
          itemStyle: {
            fontSize: '10px',
            direction: 'ltr',
            textAlign: 'left',
            width: '80px',
          },
        },
        series: [
          {
            name: '',
            keys: ['name', 'y', 'tooltipText'],
            colorByPoint: true,
            data: [],
            size: '100%',
            slicedOffset: 5,
            showInLegend: true,
            useHTML: true,
          },
        ],
        plotOptions: {
          pie: {
            innerSize: 70,
            depth: 30,
            dataLabels: {
              enabled: true,
              useHTML: true,
              style: {
                fontSize: '9px',
                textOutline: 'none',
                color: '#ffffff',
              },
            },
          },
          useHTML: true,
          series: {
            title: 'نوع کد',
            cursor: 'pointer',
            borderRadius: 5,
            dataLabels: [
              {
                enabled: true,
                distance: 15,
                format: '{point.name}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
              {
                enabled: true,
                distance: '-20%',
                format: '{point.y}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
            ],
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{point.tooltipText}</span>: <span  style="color:white">{point.y}</span></div><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">درصد</span>: <span  style="color:white">{point.percentage:.2f}</span></div>',
        },
      },
      //row 3
      dashboardIMG: require('@/assets/images/dashboard800Image.png'),

      callsColumnChartOptions: {
        chart: {
          type: 'column',
          height: '240px',
        },
        title: {
          text: '',
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        exporting: {
          chartOptions: {
            xAxis: [
              {
                labels: {
                  rtl: true,
                  style: {
                    fontSize: '7px',
                    color: '#000000',
                    direction: 'ltr',
                    textAlign: 'right',
                    width: '170px',
                    wordWrap: 'break-word',
                  },
                  rotation: -45,
                },
                tickLength: 0,
              },
            ],
          },
        },
        xAxis: {
          type: 'category',
          useHTML: true,
          reversed: true,
          labels: {
            style: {
              fontSize: '9px',
              color: '#000000',
              textAlign: 'right',
              width: '120px',
              wordWrap: 'break-word',
            },
            useHTML: true,
          },
          tickLength: 0,
        },
        yAxis: {
          title: {
            text: '',
          },
          opposite: false,
          useHTML: true,
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            color: '#665FBB',
            useHTML: true,
            dataLabels: {
              enabled: true,
              y: -42,
              verticalAlign: 'top',
              format: '{point.text}',
              x: 0,
              style: {
                fontWeight: 'bold',
                color: '#665FBB',
                fontSize: '12px',
              },
              useHTML: true,
            },
          },
          column: {
            depth: 25,
          },
        },
        tooltip: {
          useHTML: true,

          headerFormat: '<span class="tooltipHeader" style="color:#ffffff;"></span>',
          pointFormat:
            '<div class="tooltipPointWrapper">‎' +
            '<span style="color:#ffffff">{point.name}</span>: <span  style="color:#ffffff">{point.text}</span></div>',
        },
        series: [
          {
            name: 'تماس ها',
            keys: ['name', 'y', 'text'],
            data: [],
          },
        ],
      },
      //row 4
      dignosisColumnChartOptions: {
        chart: {
          type: 'column',
          height: '240px',
        },
        title: {
          text: '',
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        exporting: {
          chartOptions: {
            xAxis: [
              {
                labels: {
                  rtl: true,
                  style: {
                    fontSize: '7px',
                    color: '#000000',
                    direction: 'ltr',
                    textAlign: 'right',
                    width: '170px',
                    wordWrap: 'break-word',
                  },
                  rotation: -45,
                },
                tickLength: 0,
              },
            ],
          },
        },
        xAxis: {
          type: 'category',
          useHTML: true,
          reversed: true,
          labels: {
            style: {
              fontSize: '9px',
              color: '#000000',
              textAlign: 'right',
              width: '120px',
              wordWrap: 'break-word',
            },
            useHTML: true,
          },
          tickLength: 0,
        },
        yAxis: {
          title: {
            text: '',
          },
          opposite: false,
          useHTML: true,
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            color: '#FFBD55',
            useHTML: true,
            dataLabels: {
              enabled: false,
              format: '{point.text}',
              x: 2,
              style: {
                fontWeight: 'normal',
                color: '#000000',
                fontSize: '12px',
              },
              useHTML: true,
            },
          },
          column: {
            depth: 25,
          },
        },
        tooltip: {
          useHTML: true,
          headerFormat: '<span class="tooltipHeader" style="color:#ffffff;"></span>',
          pointFormat:
            '<div class="tooltipPointWrapper">‎' +
            '<span style="color:#ffffff">{point.name}</span>: <span  style="color:#ffffff">{point.text}</span></div>',
        },
        series: [
          {
            name: 'تشخیص ها',
            keys: ['name', 'y', 'text'],
            data: [],
          },
        ],
      },
      //row 5
      //line mission chart
      missionLineChart: {
        chart: {
          type: 'spline',
          height: '240px',
          zoomType: 'x',
          resetZoomButton: {
            position: {
              verticalAlign: 'top',
              align: 'left',
            },
          },
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        xAxis: {
          type: 'datetime',
        },
        legend: {
          enabled: false,
        },
        yAxis: {
          title: {
            text: '',
          },
          labels: {
            format: '{value}',
          },
        },
        tooltip: {
          useHTML: true,
          crosshairs: true,
          shared: true,
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: '#666666',
              lineWidth: 1,
            },
          },
        },
        series: [
          {
            name: 'ماموریت ها',
            marker: {
              symbol: 'diamond',
            },
            data: [],
          },
        ],
      },
      //row 6
      patientColumnChartOptions: {
        chart: {
          type: 'column',
          height: '240px',
        },
        title: {
          text: '',
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        exporting: {
          chartOptions: {
            xAxis: [
              {
                labels: {
                  rtl: true,
                  style: {
                    fontSize: '7px',
                    color: '#000000',
                    direction: 'ltr',
                    textAlign: 'right',
                    width: '170px',
                    wordWrap: 'break-word',
                  },
                  rotation: -45,
                },
                tickLength: 0,
              },
            ],
          },
        },
        xAxis: {
          type: 'category',
          useHTML: true,
          reversed: true,
          labels: {
            style: {
              fontSize: '9px',
              color: '#000000',
              textAlign: 'right',
              width: '120px',
              wordWrap: 'break-word',
            },
            useHTML: true,
          },
          tickLength: 0,
        },
        yAxis: {
          title: {
            text: '',
          },
          opposite: false,
          useHTML: true,
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            color: '#EB5593',
            useHTML: true,
            dataLabels: {
              enabled: false,
              format: '{point.text}',
              x: 2,
              style: {
                fontWeight: 'normal',
                color: '#000000',
                fontSize: '12px',
              },
              useHTML: true,
            },
          },
          column: {
            depth: 25,
          },
        },
        tooltip: {
          useHTML: true,
          headerFormat: '<span class="tooltipHeader" style="color:#ffffff;"></span>',
          pointFormat:
            '<div class="tooltipPointWrapper">‎' +
            '<span style="color:#ffffff">{point.name}</span>: <span  style="color:#ffffff">{point.text}</span></div>',
        },
        series: [
          {
            name: 'نتیجه مددجویان',
            keys: ['name', 'y', 'text'],
            data: [],
          },
        ],
      },
      //row 7
      missionPhoneColumnChartOptions: {
        chart: {
          type: 'column',
          height: '240px',
        },
        title: {
          text: '',
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        exporting: {
          chartOptions: {
            xAxis: [
              {
                labels: {
                  rtl: true,
                  style: {
                    fontSize: '7px',
                    color: '#000000',
                    direction: 'ltr',
                    textAlign: 'right',
                    width: '170px',
                    wordWrap: 'break-word',
                  },
                  rotation: -45,
                },
                tickLength: 0,
              },
            ],
          },
        },
        xAxis: {
          type: 'category',
          useHTML: true,
          reversed: true,
          labels: {
            style: {
              fontSize: '9px',
              color: '#000000',
              textAlign: 'right',
              width: '120px',
              wordWrap: 'break-word',
            },
            useHTML: true,
          },
          tickLength: 0,
        },
        yAxis: {
          title: {
            text: '',
          },
          opposite: false,
          useHTML: true,
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            color: '#5CB7BD',
            useHTML: true,
            dataLabels: {
              enabled: false,
              format: '{point.text}',
              x: 2,
              style: {
                fontWeight: 'normal',
                color: '#000000',
                fontSize: '12px',
              },
              useHTML: true,
            },
          },
          column: {
            depth: 25,
          },
        },
        tooltip: {
          useHTML: true,
          headerFormat: '<span class="tooltipHeader" style="color:#ffffff;"></span>',
          pointFormat:
            '<div class="tooltipPointWrapper">‎' +
            '<span style="color:#ffffff">{point.name}</span>: <span  style="color:#ffffff">{point.text}</span></div>',
        },
        series: [
          {
            name: 'نتیجه مددجویان',
            keys: ['name', 'y', 'text'],
            data: [],
          },
        ],
      },
    };
  },
  methods: {
    readyDashboard: function (data) {
      // fence and manual time
      this.callTillArriveToLocationAverageTime.city = this.convertSecondsToTime(
        data?.callTillArriveToLocationAverageTimeCity?.valueDouble,
      );
      this.callTillArriveToLocationAverageTime.road = this.convertSecondsToTime(
        data?.callTillArriveToLocationAverageTimeRoad?.valueDouble,
      );
      this.fenceCallTillArriveToLocationAverageTime.city = this.convertSecondsToTime(
        data?.fenceCallTillArriveToLocationAverageTimeCity?.valueDouble,
      );
      this.fenceCallTillArriveToLocationAverageTime.road = this.convertSecondsToTime(
        data?.fenceCallTillArriveToLocationAverageTimeRoad?.valueDouble,
      );

      //
      this.moveFromLocationTillArriveToHospitalAverageTime.city = this.convertSecondsToTime(
        data?.moveFromLocationTillArriveToHospitalAverageTimeCity?.valueDouble,
      );
      this.moveFromLocationTillArriveToHospitalAverageTime.road = this.convertSecondsToTime(
        data?.moveFromLocationTillArriveToHospitalAverageTimeRoad?.valueDouble,
      );
      this.fenceMoveFromLocationTillArriveToHospitalAverageTime.city = this.convertSecondsToTime(
        data?.fenceMoveFromLocationTillArriveToHospitalAverageTimeCity?.valueDouble,
      );
      this.fenceMoveFromLocationTillArriveToHospitalAverageTime.road = this.convertSecondsToTime(
        data?.fenceMoveFromLocationTillArriveToHospitalAverageTimeRoad?.valueDouble,
      );
      //row 1
      this.callsCount = data?.callsCount ? data.callsCount?.valueLong : '';
      this.accidentsCount = data.accidentsCount ? data.accidentsCount.valueLong : '';
      this.missionPhonesCount = data.missionPhonesCount ? data.missionPhonesCount.valueLong : '';
      this.patientsCount = data.patientsCount ? data.patientsCount.valueLong : '';
      //row 2
      //pie rank chart
      let pieChartData = JSON.parse(JSON.stringify([]));
      let pieChartTempArray = JSON.parse(JSON.stringify([]));
      pieChartTempArray = JSON.parse(JSON.stringify(data.missionsByRank));
      this.dashboardPieRankChartOptions.colors = [];
      // this.dashboardPieRankChartOptions.colors = [...pieChartTempArray].map(
      //   eachItem => {
      //     let color = ''
      //     switch (eachItem?.title) {
      //       case 'قرمز':
      //         color = '#DA6757'
      //         break
      //       case 'سبز':
      //         color = 'green'
      //         break
      //       case 'سفید':
      //         color = 'white'
      //         break
      //       default:
      //         color = 'yellow'
      //         break
      //     }
      //     return color
      //   }
      // )
      for (let i = 0; i < pieChartTempArray.length; i++) {
        if (pieChartTempArray[i].title == 'سفید') {
          this.dashboardPieRankChartOptions.colors.push('#EBEBEB');
        } else if (pieChartTempArray[i].title == 'سبز') {
          this.dashboardPieRankChartOptions.colors.push('#2EBA7F');
        } else if (pieChartTempArray[i].title == 'زرد') {
          this.dashboardPieRankChartOptions.colors.push('#FFBD55');
        } else if (pieChartTempArray[i].title == 'قرمز') {
          this.dashboardPieRankChartOptions.colors.push('#DA6757');
        }
        pieChartData.push({
          name: pieChartTempArray[i].title,
          y: pieChartTempArray[i].valueLong,
          tooltipText: 'تعداد',
        });
      }
      pieChartData = JSON.parse(JSON.stringify(pieChartData));
      // this.dashboardPieRankChartOptions.series[0].data = [];
      this.dashboardPieRankChartOptions.series[0].data = [...pieChartData];
      //pie Geographical
      let pieChartData2 = JSON.parse(JSON.stringify([]));
      let pieChartTempArray2 = JSON.parse(JSON.stringify([]));
      pieChartTempArray2 = JSON.parse(JSON.stringify(data.missionsByGeographicalType));
      for (let i = 0; i < pieChartTempArray2.length; i++) {
        pieChartData2.push({
          name: pieChartTempArray2[i].title,
          y: pieChartTempArray2[i].valueLong,
          tooltipText: 'تعداد',
        });
      }
      pieChartData2 = JSON.parse(JSON.stringify(pieChartData2));
      this.pieGeographicalChartOption.series[0].data = [];
      this.pieGeographicalChartOption.series[0].data = pieChartData2;
      //code Type pie
      let pieChartData3 = JSON.parse(JSON.stringify([]));
      let pieChartTempArray3 = JSON.parse(JSON.stringify([]));
      pieChartTempArray3 = JSON.parse(JSON.stringify(data.missionsPhonesByVehicleType));
      for (let i = 0; i < pieChartTempArray3.length; i++) {
        pieChartData3.push({
          name: pieChartTempArray3[i].title,
          y: pieChartTempArray3[i].valueLong,
          tooltipText: 'تعداد',
        });
      }
      pieChartData3 = JSON.parse(JSON.stringify(pieChartData3));
      this.pieCodeTypeChartOption.series[0].data = [];
      this.pieCodeTypeChartOption.series[0].data = pieChartData3;
      //row 3
      // let duration = Math.round(
      //   data.callTillArriveToLocationAverageTime.valueDouble
      //     ? data.callTillArriveToLocationAverageTime.valueDouble
      //     : data.callTillArriveToLocationAverageTime.valueLong
      // );
      // duration = duration * 1000;
      // this.callTillArriveToLocationAverageTime = this.msToTime(duration);

      // let duration2 = Math.round(
      //   data.moveFromLocationTillArriveToHospitalAverageTime.valueDouble
      // );
      // duration2 = duration2 * 1000;
      // this.moveFromLocationTillArriveToHospitalAverageTime =
      //   this.msToTime(duration2);
      //column chart
      let coluumnCallChartData = JSON.parse(JSON.stringify([]));
      let coluumnCallTempArray = JSON.parse(JSON.stringify([]));
      coluumnCallTempArray = JSON.parse(JSON.stringify(data.callsByTag));
      for (let i = 0; i < coluumnCallTempArray.length; i++) {
        coluumnCallChartData.push({
          name: coluumnCallTempArray[i].title,
          y: coluumnCallTempArray[i].valueLong,
          text: coluumnCallTempArray[i].valueLong.toString(),
        });
      }
      coluumnCallChartData = JSON.parse(JSON.stringify(coluumnCallChartData));
      this.callsColumnChartOptions.series[0].data = [];
      this.callsColumnChartOptions.series[0].data = coluumnCallChartData;
      //row 4
      let coluumnDiagnosChartData = JSON.parse(JSON.stringify([]));
      let coluumnDiagnosTempArray = JSON.parse(JSON.stringify([]));
      coluumnDiagnosTempArray = JSON.parse(JSON.stringify(data.patientDiagnoses));
      for (let i = 0; i < coluumnDiagnosTempArray.length; i++) {
        coluumnDiagnosChartData.push({
          name: coluumnDiagnosTempArray[i].title,
          y: coluumnDiagnosTempArray[i].valueLong,
          text: coluumnDiagnosTempArray[i].valueLong.toString(),
        });
      }
      coluumnDiagnosChartData = JSON.parse(JSON.stringify(coluumnDiagnosChartData));
      this.dignosisColumnChartOptions.series[0].data = [];
      this.dignosisColumnChartOptions.series[0].data = coluumnDiagnosChartData;
      //row 5
      if (data.missionPhonesByDate.length > 0) {
        for (let i = 0; i < data.missionPhonesByDate.length; i++) {
          let date2 = new Date(data.missionPhonesByDate[i].title.toString());
          let date3 = date2.toString();
          let splitForTime = date3.split(' ');
          let time = splitForTime[4];
          let splitedTime = time.split(':');
          let today = new Date(date2).toLocaleDateString('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            formatMatcher: 'basic',
          });
          let sp = today.split('/');
          this.missionLineChart.series[0].data.push([
            Date.UTC(sp[2], sp[0] - 1, sp[1], splitedTime[0], splitedTime[1], '00'),
            data.missionPhonesByDate[i].valueLong,
          ]);
        }
      }
      //row 6
      let coluumnpatientChartData = JSON.parse(JSON.stringify([]));
      let coluumnpatientTempArray = JSON.parse(JSON.stringify([]));
      coluumnpatientTempArray = JSON.parse(JSON.stringify(data.patientResults));
      for (let i = 0; i < coluumnpatientTempArray.length; i++) {
        coluumnpatientChartData.push({
          name: coluumnpatientTempArray[i].title,
          y: coluumnpatientTempArray[i].valueLong,
          text: coluumnpatientTempArray[i].valueLong.toString(),
        });
      }
      coluumnpatientChartData = JSON.parse(JSON.stringify(coluumnpatientChartData));
      this.patientColumnChartOptions.series[0].data = [];
      this.patientColumnChartOptions.series[0].data = coluumnpatientChartData;
      //row 6
      let coluumnmissionPhoneChartData = JSON.parse(JSON.stringify([]));
      let coluumnmissionPhoneTempArray = JSON.parse(JSON.stringify([]));
      coluumnmissionPhoneTempArray = JSON.parse(JSON.stringify(data.missionPhoneResults));
      for (let i = 0; i < coluumnmissionPhoneTempArray.length; i++) {
        coluumnmissionPhoneChartData.push({
          name: coluumnmissionPhoneTempArray[i].title,
          y: coluumnmissionPhoneTempArray[i].valueLong,
          text: coluumnmissionPhoneTempArray[i].valueLong.toString(),
        });
      }
      coluumnmissionPhoneChartData = JSON.parse(JSON.stringify(coluumnmissionPhoneChartData));
      this.missionPhoneColumnChartOptions.series[0].data = [];
      this.missionPhoneColumnChartOptions.series[0].data = coluumnmissionPhoneChartData;
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    convertSecondsToTime: function (s) {
      if (!s) return '00:00';
      else {
        const intSecond = Number(s).toFixed(0);
        // const hours = parseInt(intSecond / 3600)
        //   .toString()
        //   .padStart(2, "0");
        const minutes = parseInt((intSecond % 3600) / 60)
          .toString()
          .padStart(2, '0');
        const seconds = (intSecond % 60).toString().padStart(2, '0');
        return `${minutes}:${seconds}`;
      }
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
    setPreTimes: function () {
      this.tempSearchFromDate = '00:00:00 ';
      let temp = Vue.moment().format('jYYYY-jMM-jDD');
      this.tempSearchFromDate += temp;
      this.searchFromDate = null;
      // this.searchFromDate += "T07:30:00";
      this.searchToDate = Vue.moment().format('YYYY-MM-DDTHH:mm:ss');
      this.tempSearchToDate = Vue.moment().format('HH:mm:ss jYYYY-jMM-jDD');
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.searchModal = false;
      this.isSearch = true;
      this.getStatisticsMainDashboardFunction(this.searchFromDate, this.searchToDate);
    },
    removeFilters: function () {
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.isSearch = false;
      this.getStatisticsMainDashboardFunction(this.searchFromDate, this.searchToDate);
    },
    cancelSearch: function () {
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.searchModal = false;
    },
    refreshList: function () {
      this.getStatisticsMainDashboardFunction(this.searchFromDate, this.searchToDate);
    },
  },
  watch: {
    searchModal: function (searchModalVal) {
      if (searchModalVal && !this.searchFromDate) {
        this.searchFromDate = Vue.moment(new Date()).format('YYYY-MM-DDT00:00:00');
      }
    },
  },
};
